// extracted by mini-css-extract-plugin
export default {"logoPage":"LogoPage_logoPage__Z+bmR","logo":"LogoPage_logo__ix2LK"};